const RightMenus = () => {
  return (
    <div className="flex gap-1 text-slate-400">
      <button className="sm:w-6 md:w-8 sm:h-6 md:h-8 rounded-full flex justify-center items-center hover:bg-slate-200">
        <i className="fa-solid fa-phone-volume sm:text-xs md:text-base"></i>
      </button>
      <button className="sm:w-6 md:w-8 sm:h-6 md:h-8 rounded-full flex justify-center items-center hover:bg-slate-200">
        <i className="fa-solid fa-video sm:text-xs md:text-base"></i>
      </button>
      <button className="sm:w-6 md:w-8 sm:h-6 md:h-8 rounded-full flex justify-center items-center hover:bg-slate-200">
        <i className="fa-solid fa-ellipsis-vertical sm:text-xs md:text-base"></i>
      </button>
    </div>
  );
};

export default RightMenus;
